import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const LetterService = {

  getAllHead: async () => {
    try {
      const response = await axios.get(ENDPOINT.Head);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  createHead: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Head, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  updateHead: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Head}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  deleteHead: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Head}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  deleteDgSign: async (name) => {
    try {
      const response = await axios.delete(`${ENDPOINT.digitalSign}/${name}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  deleteDgSignDb: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.deleteDgSignDb}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  getAllDGUpload: async () => {
    try {
      const response = await axios.get(ENDPOINT.getAllDgSignDb);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  // footer-org
  getAllFooter: async () => {
    try {
      const response = await axios.get(ENDPOINT.footer);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  createFooter: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.footer, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  updateFooter: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.footer}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  deleteFooter: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.footer}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  // terms and condition

  getAllTC: async () => {
    try {
      const response = await axios.get(ENDPOINT.TC);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  createTC: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.TC, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  updateTC: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.TC}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  deleteTC: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.TC}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

  patchTC: async (id, data) => {
    try {
      const response = await axios.patch(`${ENDPOINT.TC}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Head:", error.message);
      throw error;
    }
  },

};
